import CupReducer from './cup';
import ModalReducer from './modal';
import TimerReducer from './timer';
import TriggerReducer from './trigger';

export default ({ cup, modal, timer, trigger }, action) => ({
  cup: CupReducer(cup, action),
  modal: ModalReducer(modal, action),
  timer: TimerReducer(timer, action),
  trigger: TriggerReducer(trigger, action),
});
